import React from 'react';
import Dialog from '@mui/material/Dialog';
import { useSelector, useDispatch } from 'react-redux';

import AboutModal from './AboutModal';
import HelpModal from './HelpModal';
import EditModal from './EditModal';
import ConfirmModal from './ConfirmModal';

import { closeModal } from '../../reducers/modal';
import ConfirmDownload from './ConfirmDownlaod';

export const modalTypes = {
  ABOUT_MODAL: 'ABOUT_MODAL',
  HELP_MODAL: 'HELP_MODAL',
  EDIT_MODAL: 'EDIT_MODAL',
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  CONFIRM_DOWNLOAD: 'CONFIRM_DOWNLOAD',
};

const styles = {
  title: {
    background: '#22467F',
    padding: '10px 24px',
  },
  content: {
    background: '#1B3664',
    fontWeight: 300,
    paddingTop: '1rem',
  },
  link: {
    color: '#FFFFC0',
    textDecoration: 'none',
  },
};

const Modal = () => {
  const { open, type, data } = useSelector((state) => state.modal);

  // hide modal if not open
  const dispatch = useDispatch();

  if (!open) return '';

  const onClose = () => {
    dispatch(closeModal());
  };

  let Content;

  switch (type) {
    case modalTypes.HELP_MODAL:
      Content = HelpModal;
      break;
    case modalTypes.EDIT_MODAL:
      Content = EditModal;
      break;
    case modalTypes.CONFIRM_MODAL:
      Content = ConfirmModal;
      break;
    case modalTypes.CONFIRM_DOWNLOAD:
      Content = ConfirmDownload;
      break;
    default:
      Content = AboutModal;
      break;
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <Content styles={styles} data={data} />
    </Dialog>
  );
};

export default Modal;
